import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches all appointments for a patient. */
export function useListPatientAppointments(patientId: string) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['patient-appointments', patientId],
    queryFn: async () => {
      const response = await api.get('/appointments', { query: { patientId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.appointments
    },
  })
}
